window.Helper =
  inputToFloat: (inputString) ->
      parseFloat(parseFloat(inputString.replace(/[,]/g, ".")).toFixed(2))

  escapeString: (value) ->
    return value if typeof value != 'string'
    _.escape(value)

  flashRow: ($el, color_code) ->
    prev_color = $el.css("background-color")
    $el.animate({
      backgroundColor: color_code
    }, 1000 ).animate({
      backgroundColor: prev_color
    }, 1000, ->
      $el.css("background-color", "")
    )

  parseDate: (dateString) ->
    return null unless dateString
    parts = dateString.split('-')
    return null if parts.length != 3

    day = parseInt(parts[0], 10)
    month = parseInt(parts[1], 10) - 1  # JS months are 0-indexed
    year = parseInt(parts[2], 10)

    new Date(year, month, day)
